import { z } from 'zod';
import { IndicatorType } from '@shared/types';

export const MacdInputSchema = z.object({
  type: z.literal(IndicatorType.MACD),
  fastPeriod: z.number().optional(),
  slowPeriod: z.number().optional(),
  signalPeriod: z.number().optional()
});

export type MacdInput = z.infer<typeof MacdInputSchema>;
